import { Component, OnInit, Input } from '@angular/core'
import Moment from 'moment'
import 'twix'

const moment = Moment as any

@Component({
  selector: 'app-event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.scss']
})
export class EventCardComponent implements OnInit {
  @Input() event: any

  get date(): string {
    const range = moment(this.event.startDate).twix(this.event.endDate, {
      allDay: true
    })
    return range.format()
  }

  constructor() {}

  ngOnInit() {}
}
